import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
    align-items: center;
    background-color: white;
    border-radius: 50px;
    display: flex;
    justify-content: center;
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 24px;
    background: white;
    border-radius: 50px;
    color: ${theme.v2.colors.brand.primaryMedium};
    cursor: pointer;
    justify-content: flex-start;
    border: 1px solid ${theme.v2.colors.brand.primaryMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};

    background-image: linear-gradient(90deg, ${theme.v2.colors.brand.primaryMedium}, ${theme.v2.colors.brand.primaryExtraDark});
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    @media (max-width: ${theme.v2.breakpoints.md}){
      padding: 12px 9px;
    }
  `};
`;

export const Icon = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}){
      display: none;
    }
  `};
`;

const blink = keyframes`
  0%, 50% {
    visibility: visible;
  }
  51%, 100% {
    visibility: hidden;
  }
`;

export const BlinkingCursor = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};

    animation: ${blink} 1s infinite linear;
  `};
`;

export const Text = styled.div``;
